//Finance calculator
import $ from 'jquery';

var financeCalculator = (function() {
    var app = {
        $win: $(window),
        $doc: $(document),
        $body: $('body')
    };
	app.polaroidMonthlyAmount = function() {
        var $li = $(this);
        var price = parseInt( $('.finance_calculator .total_price').text().replace(/[^\d]/g, '') );
        var deliveryCosts = parseFloat($('.finance-delivery-costs .amount').first().text().replace(/,/, '.'));
        var ownShare = Math.round(price * 0.1);
        var payments = 48;
        var monthlyPrice = app.calcFinance(price, ownShare, payments, 0, 0);
        $li.find('.monthlyfee .amount').text(monthlyPrice);
    };

    app.prettyNumber = function(n, decimals) {
        decimals = decimals || 0;
        var exp = Math.pow(10, decimals);
        n = Math.round(n * exp) / exp;
        n = n.toString().replace('.', ',');
        return n.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    app.calcFinance = function(price, ownShare, payments, lastPayment, decimals) {

        function parseNumber(num) {
            if (typeof num == 'string') {
                num = num.replace(/,/, '.').replace(/\s/, '');
            }
            return parseFloat(num);
        }

        var doFinanceElements = typeof price == 'undefined';
        var price = parseNumber(price || $('.finance_calculator .total_price').text().replace(/€/g, ''));

        var ownShare = parseNumber(ownShare || $('.finance-own-share').val() || 0);

        if (ownShare > price) {
            ownShare = Math.max(price - 100, 0);
            $('.finance-own-share').val(ownShare);
        }

        if (ownShare < 0) {
            ownShare = 0;
            $('.finance-own-share').val(ownShare);
        }

        var payments = parseNumber(payments || $('.finance-time option:selected').val());
        var lastPayment = parseNumber(lastPayment || $('.finance-last-monthly-amount').val() || 0);

        if (lastPayment > price - ownShare) {
            lastPayment = Math.max(price - ownShare - 100, 0);
            $('.finance-last-monthly-amount').val(lastPayment);
        }

        if (lastPayment < 0) {
            lastPayment = 0;
            $('.finance-last-monthly-amount').val(lastPayment);
        }

        if (typeof decimals == 'undefined') {
            decimals = 2;
        }

        var interest = parseFloat($('.finance-interest .amount').first().text().replace(/,/g, '.')) / 100;
        var initialCost = parseFloat($('.finance-initial-amount .amount').first().text().replace(/,/, '.'));
        var monthlyHandling = parseFloat($('.finance-handling-costs .amount').first().text().replace(/,/, '.'));
        var handlingCost = monthlyHandling * payments;
        var loanAmount = price - ownShare;
        var helper = Math.pow((interest / 12.0) + 1, payments - (lastPayment ? 1 : 0));
        var initialAmount = ((loanAmount + initialCost) * (helper * (interest / 12.0))) / (helper - 1);

        if (lastPayment) {
            initialAmount -= ((lastPayment / payments) + (lastPayment * interest / payments));
        }

        var loanRemaining = loanAmount;
        var interestCurrent, interestSum = 0;
        var paymentAmount = 0;

        var i;
        for (i = 0; i < payments; i++) {
            interestCurrent = loanRemaining * interest / 12;
            if (lastPayment && i == payments - 1) {
                paymentAmount = lastPayment - interestCurrent;
            } else {
                paymentAmount = initialAmount - interestCurrent;
            }
            loanRemaining -= paymentAmount;
        }

        var x = loanRemaining / (payments - 1);
        loanRemaining = loanAmount + initialCost;
        for (i = 0; i < payments; i++) {
            interestCurrent = (loanRemaining - x) * interest / 12;
            interestSum += interestCurrent;
            if (lastPayment && i == payments - 1) {
                paymentAmount = lastPayment - interestCurrent;
            } else {
                paymentAmount = initialAmount - interestCurrent;
            }
            loanRemaining -= paymentAmount;
        }

        if (lastPayment) {
            initialAmount = initialAmount + loanRemaining / (payments - 1);
        }

        var monthlyPrice = initialAmount + monthlyHandling;
        monthlyPrice = Math.round(monthlyPrice * 100) / 100;
        var loanExpenses = interestSum + initialCost + monthlyHandling * payments;
        var yearlyInterest = lastPayment ? (2400 * (loanExpenses)) / ((loanAmount + initialCost) * payments) : (2400 * (loanExpenses)) / ((loanAmount + initialCost) * (payments + 1));

        if (doFinanceElements) {
            $('.finance-own-share-text .amount').text(app.prettyNumber(ownShare));
            $('.finance-time-text .amount').text(payments);
            $('.finance-loan-cost .amount').text(app.prettyNumber(loanExpenses, 2));
            $('.finance-yearly-interest .amount').text(app.prettyNumber(yearlyInterest, 2));
            $('.finance-loan-total-cost .amount').text(app.prettyNumber(parseFloat(loanExpenses) + parseFloat(price - ownShare), 2));
            $('.finance-total-cost .amount').text(app.prettyNumber(price + loanExpenses, 2));
            $('.finance-monthly-amount .amount').text(app.prettyNumber(monthlyPrice, 2));
            $('.finance-fund-amount .amount').text(app.prettyNumber(price - ownShare, 2));
        }

        return app.prettyNumber(monthlyPrice, decimals);
    };

    return app;
}());

module.exports = financeCalculator;